
!function ($) {
    "use strict";

    var CalendarApp = function () {
        this.$body = $("body"),
            this.$calendar = $('#calendar'),
            this.$calendarObj = null,
            this.$selectedEvent = null
    };

    /* on click on event */
    CalendarApp.prototype.onEventClick = function (info) {
        console.log(info.event);
    },

    CalendarApp.prototype.init = function (events, options) {

        if (options.onEventClick) {
            CalendarApp.prototype.onEventClick = options.onEventClick;
        }

        var $this = this;

        $this.$calendarObj = new FullCalendar.Calendar($this.$calendar[0], {
            locale: 'es',
            eventTimeFormat: {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
                meridiem: false
            },
            slotDuration: '00:15:00', /* If we want to split day time each 15minutes */
            slotMinTime: '08:00:00',
            slotMaxTime: '19:00:00',
            themeSystem: 'bootstrap',
            bootstrapFontAwesome: false,
            buttonText: {
                today: 'Hoy',
                month: 'Mes',
                week: 'Semana',
                day: 'Día',
                list: 'Lista',
                prev: 'Anterior',
                next: 'Siguiente'
            },
            initialView: 'dayGridMonth',
            handleWindowResize: true,
            height: $(window).height() - 200,
            headerToolbar: {
                left: 'prev,next today',
                center: 'title',
                right: 'dayGridMonth,timeGridWeek,timeGridDay,listMonth'
            },
            initialEvents: events,
            //editable: true,
            //droppable: true, // this allows things to be dropped onto the calendar !!!
            // dayMaxEventRows: false, // allow "more" link when too many events
            selectable: true,
            //dateClick: function (info) { $this.onSelect(info); },
            eventClick: function (info) { $this.onEventClick(info); }
        });

        $this.$calendarObj.render();
    },

    $.CalendarApp = new CalendarApp, $.CalendarApp.Constructor = CalendarApp

}(window.jQuery);

    
